module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tNa5eu/tc-custom/9781035815739.jpg?1726617311145",
      "alt": "This image is the cover for the book Diary of Two Idiots Who Know Zero About Cats, And Have Never Particularly Liked Them."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Diary of Two Idiots Who Know Zero About Cats, And Have Never Particularly Liked Them.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is a story of a homeless cat who came to visit at our stables just before Christmas, twenty-two years ago. She was very thin, hungry, and nervous. We left food outside which she ate, and then came closer to us and gradually became more friendly, so we put the food inside the animals’ storage shed, where we kept the hay supplies. Being December, the weather was cold and wet and she stayed in the shed on top of the hay. We called her Lucy, and in the Spring, she gave us an incredible surprise. Read the story to find out what this was.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ron Fones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ron Fones lives in Staffordshire, England and together with his family, has kept horses for over 40 years. He and his wife built their own stables for the horses on a paddock near to their home. Twenty-two years ago, the homeless cat arrived at the stables and Ron and his wife Pat wrote an account of what happened following the cat’s arrival. Several months ago, Ron came across the diaries and decided to try and publish the story.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0